import defaultAttributes from '../defaultAttributes';

const Moon = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M12 3a6.364 6.364 0 0 0 9 9 9 9 0 1 1-9-9Z' }]],
];

export default Moon;
